import dynamic from "next/dynamic";

export const FeaturedClients = dynamic(() => import("./component"));
